module.exports = __webpack_public_path__ + "static/img/title-concat.3cd22821.png";